import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { IFundraiser } from '../../../../fundraiser/models/fundraiser.model';
import { IUser } from '../../../../shared/models';
import { FundraiserService, UtilService, VariablesService, EventsService } from '../../../../shared/services';
import { SignupService } from '../../../../shared/services/signup/signup.service';
import { StartSupportingFrComponent } from '../start-supporting-fr/start-supporting-fr.component';

@Component({
  selector: 'app-supporting-fr-card',
  templateUrl: './supporting-fr-card.component.html',
  styleUrls: ['./supporting-fr-card.component.scss']
})
export class SupportingFrCardComponent implements OnInit, OnDestroy {

  @Input() fundraiser: IFundraiser;
  @Input() currency;
  @Input() isFundraiserEnded;
  supporters;
  page = 1;
  isLoading = false;
  showStartSupportFr = true;
  isPending = false;
  generalSubs: Subscription[] = [];
  isLoggedIn;
  userdata: IUser;
  mySopportFr;
  constructor(
    private fundraiserService: FundraiserService,
    public utilService: UtilService,
    public dialog: MatDialog,
    private variablesService: VariablesService,
    public signupService: SignupService,
    public events: EventsService
  ) { }

  ngOnInit() {
    this.generalSubs.push(this.utilService.isLoggedIn.subscribe({
      next: res => {
        this.getSupportingFrList(this.currency, res, 1);
        this.isLoggedIn = res;
      }
    }));
    this.generalSubs.push(this.variablesService.userData.subscribe({ next: res => this.userdata = res }));
  }

  /**Send donor objec using observalble */
  sendDonorListObject(page) {
    const donorList = {
      orderby: 'donated_amount',
      sortby: 'desc',
      page: page
    };
    this.getSupportingFrList(this.currency, this.isLoggedIn, donorList.page);
  }
  /**pagination */
  setPagination(pageAction) {
    if (pageAction === 'next') {
      this.sendDonorListObject(++this.page);
    } else {
      if (this.page >= 1) {
        this.sendDonorListObject(--this.page);
      }
    }
  }
  /**Go to supporting fr */
  goToMySupportFr(data) {
    const url = `${this.utilService.domain_details.domain_url}/supportfundraiser/${data.custom_tag}`;
    this.utilService.nativeNavigation(url);
  }
  /**Check if ended and there is no supporting fundraiser
   * then donot show the list
   */
  checkIfEndedAndNoSupportFr() {
    return (this.supporters && this.supporters.data && this.supporters.data.length) || !this.isFundraiserEnded;
  }
  /**Open the start new supporting fundrasier popup */
  openDialog(template) {
    this.events.userGTMEvents({
      event: 'fundraiser_click',
      event_category: 'fundraiser',
      event_action: 'start a supporting fundraiser',
      event_label: this.fundraiser.title
    });
    if (this.isLoggedIn) {
      this.openSupportFrDialog();
    } else {
      this.signupService.openSignUp(template, 'si', () => {
        this.openSupportFrDialog();
      });
    }
  }
  /**OPen start supporting fundraiser popup */
  openSupportFrDialog() {
    this.dialog.open(StartSupportingFrComponent, {
      data: { id: this.variablesService.fundraiser.id },
      height: '100vh',
      maxHeight: this.utilService.isMobile() ? '100vh' : '584px',
      width: '100vw',
      maxWidth: this.utilService.isMobile() ? '100vw' : '600px',
    });
  }
  /**Ge the supporting fundraiser list */
  getSupportingFrList(currency, isLoggedIn, page) {
    this.isLoading = true;
    const qPram = `?with=raised;entity.avtar&limit=5&search=status_flag:1&page=${page}&currency=${currency}`;
    this.fundraiserService.getSupportingFrList(this.fundraiser.id, qPram).subscribe((res: any) => {
      this.supporters = res.data;
      this.isLoading = false;
      if (isLoggedIn && this.supporters && this.supporters.data && this.supporters.data.length) {
        this.startSupportFr();
      }
    }, () => {
      this.isLoading = false;
    });
  }
  /**Set start supporting fundraiser button false,
   * if already created by the current user
  */
  startSupportFr() {
    const qParam = `?search=creator_entity_details_id:${this.userdata.id}&limit=1`;
    this.fundraiserService.checkIfUserHasSupportFr(this.variablesService.fundraiser.id, qParam).subscribe((res: any) => {
      if (res.data && res.data.data && res.data.data.length) {
        this.showStartSupportFr = false;
        this.mySopportFr = res.data.data[0];
        if (this.mySopportFr.status_flag === '3') {
          this.isPending = true;
        }
      }
    });
  }

  ngOnDestroy() {
    this.generalSubs.forEach(s => s.unsubscribe());
  }

}
